var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 55,
    viewBox: "0 0 87 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.1602 29.7656L60.9727 53.9531C59.9648 54.9609 58.1172 54.9609 57.1094 53.9531C56.1016 52.9453 56.1016 51.0977 57.1094 50.0898L76.7617 30.4375H2.6875C1.17578 30.4375 0 29.2617 0 27.75C0 26.4062 1.17578 25.0625 2.6875 25.0625H76.7617L57.1094 5.57812C56.1016 4.57031 56.1016 2.72266 57.1094 1.71484C58.1172 0.707031 59.9648 0.707031 60.9727 1.71484L85.1602 25.9023C86.168 26.9102 86.168 28.7578 85.1602 29.7656Z",
    fill: "#2FB4AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowRight);
export default __webpack_public_path__ + "static/media/long-arrow-right.a96d8694d35fd3f46e023e19db98359a.svg";
export { ForwardRef as ReactComponent };